import React, { PropsWithChildren, useState } from 'react';
import { PopperProps, Portal } from '@mui/material';

import { useActiveBlurb } from '../context';
import { isPartOfDocumentLayout } from '../util/isPartOfDocumentLayout';
import { NextBlurbPopper } from './BlurbPopper';
import { HoleyBackdrop } from './HoleyBackdrop';
import { backdropSx } from './styles';

interface Props {
  id: string;
  blurbPlacement: NonNullable<PopperProps['placement']> | 'centered';
}

export function WalkthroughBlurbAnchor(props: PropsWithChildren<Props>) {
  const [anchorContents, setAnchorContents] = useState<HTMLElement | null>(null);

  const activeBlurb = useActiveBlurb();

  let activeBlurbElement;

  if (activeBlurb && activeBlurb.anchor === props.id) {
    if (
      anchorContents == null ||
      anchorContents.children.length === 0 ||
      // FIXME: this check prevents duplicate components when rendered from the design client's right sidebar. I'm not
      //   sure why this is necessary and fear it could be hiding a deeper problem.
      !isPartOfDocumentLayout(anchorContents.children[0])
    ) {
      console.error(`Walkthrough blurb failed to render -- ${props.id} could not find a suitable anchor element.`);
    } else {
      activeBlurbElement = (
        <Portal>
          <HoleyBackdrop margin={8} surroundingElement={anchorContents.children[0] as HTMLElement} sx={backdropSx} />

          <NextBlurbPopper
            title={activeBlurb.title}
            placement={props.blurbPlacement}
            anchorEl={anchorContents.children[0] as HTMLElement}
          >
            {activeBlurb.renderContent()}
          </NextBlurbPopper>
        </Portal>
      );
    }
  }

  return (
    <>
      <div style={{ display: 'contents' }} ref={setAnchorContents}>
        {React.Children.only(props.children)}
      </div>

      {activeBlurbElement}
    </>
  );
}
